const DEFAULT_RETRIES = 2;
const DEFAULT_BASE_DELAY_MS = 200;

// Best effort: browsers that still cache failed module fetches reject a same-URL retry at
// once, and a chunk removed by a redeploy stays gone (dashboard Skew Protection covers that).
export function importWithRetry<T>(
  importFn: () => Promise<T>,
  { retries = DEFAULT_RETRIES, baseDelayMs = DEFAULT_BASE_DELAY_MS } = {},
): () => Promise<T> {
  return async () => {
    let lastError: unknown;
    for (let attempt = 0; attempt <= retries; attempt += 1) {
      try {
        return await importFn();
      } catch (error) {
        lastError = error;
        if (attempt === retries) break;
        await new Promise(resolve => setTimeout(resolve, baseDelayMs * 2 ** attempt));
      }
    }
    throw lastError;
  };
}
